import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";
import { WORKFLOW_NAME_MAP } from "../data/customWorkflowsList";
import { GettingStartedOption } from "../components/GettingStartedOption";
import { OptionCard } from "../components/OptionCard";
import ToolTip from "../../../../parts/tooltip";
import { pullOptions, pushOptions } from "../data/getting-started";

export const GettingStarted = (_, { locals }) => {
  const { _id, type, options } = locals.workflow;
  const access = locals?.query?.access ?? "push";
  const opts = access === "push" ? pushOptions : pullOptions;

  return (
    <main className="getting-started">
      <header>
        <hgroup>
          <SvgIcon
            src="/img/new-icons/back-button.svg"
            onClickFn={() => {
              submit(`/actions/refresh/?`, {
                method: "GET",
                body: { workflow: "", type: "" },
              });
            }}
          />
          <div>
            <h3>{WORKFLOW_NAME_MAP[type]}</h3>
          </div>
        </hgroup>
      </header>

      <div>
        <aside>
          <div className="flex justify-between items-center gap-2 mb-6">
            <h4>List of Options</h4>
            <ToolTip
              id="options-tooltip"
              body="When the option is published, users will be able to see it in the app."
            >
              <SvgIcon
                alt="info icon"
                src="/img/new-icons/question-circle.svg"
              />
            </ToolTip>
          </div>

          {Object.keys(opts).map((key) => (
            <GettingStartedOption
              key={options[key]?._id ?? key}
              option={key}
              optionObj={options[key]}
              workflow={_id}
            />
          ))}
        </aside>
        <section>
          {Object.keys(opts).map((key) => (
            <OptionCard
              key={`card-${options[key]?._id ?? key}`}
              option={key}
              optionObj={options[key]}
            />
          ))}
        </section>
      </div>
    </main>
  );
};
